import type { TFunction } from 'i18next';
import { Link } from 'react-router-dom';

export type NavTab = { to: string; label: string };

export const renderTabLink = (
  tab: NavTab,
  t: TFunction,
  selectedTab: string,
  setSelectedTab: (tab: string) => void,
  options?: { className?: string; onNavigate?: () => void }
) => {
  const isSelected = selectedTab === tab.to;
  const label = t(`navbar.display.${tab.label}`);
  return (
    <Link
      key={tab.to}
      to={`/${tab.to}`}
      className={
        options?.className ??
        'text-core-white hover:text-core-white/80 transition-colors duration-200 text-body-lg'
      }
      onClick={() => {
        setSelectedTab(tab.to);
        options?.onNavigate?.();
      }}
    >
      <div className="relative inline-block whitespace-nowrap">
        {/* This prevents text from jumping when font weight changes */}
        <div className="invisible font-bold">{label}</div>
        <div className={`absolute left-0 top-0 ${isSelected ? 'font-bold' : 'font-normal'}`}>
          {label}
        </div>
      </div>
    </Link>
  );
};
